import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { Icons } from '../../../shared/icons';
import { GAS_CLASSIFICATION_LABELS } from '../../../data/mappers';

export default function ClassificationSelector({ 
  value, 
  onChange, 
  perFault = false,
  errors = []
}) {
  const classifications = [
    { key: 'immediately_dangerous', label: 'Immediately Dangerous (ID)', icon: Icons.AlertTriangle, color: 'danger' },
    { key: 'at_risk', label: 'At Risk (AR)', icon: Icons.AlertCircle, color: 'warning' },
    { key: 'not_to_current_standards', label: 'Not to Current Standards (NCS)', icon: Icons.Info, color: 'caution' },
    { key: 'safe_to_use', label: 'Safe to Use', icon: Icons.CheckCircle, color: 'success' }
  ];

  const colorClasses = {
    danger: 'bg-red-600 text-white border-red-800',
    warning: 'bg-orange-500 text-white border-orange-700',
    caution: 'bg-yellow-500 text-black border-yellow-700',
    success: 'bg-green-600 text-white border-green-800'
  };

  return (
    <div className="classification-selector">
      <label>
        <span className="eyebrow">Safety Classification</span>
        <span className="classification-label">
          {perFault ? 'Fault Classification' : 'Overall Installation Classification'}
        </span>
      </label>
      
      <div className="classification-options">
        {classifications.map(({ key, label, icon, color }) => (
          <button
            key={key}
            type="button"
            className={`classification-option ${colorClasses[color]} ${value === key ? 'selected' : ''}`}
            onClick={() => onChange(key)}
            aria-label={`Select ${label}`}
            aria-pressed={value === key}
          >
            <SafeIcon icon={icon} size={24} />
            <span className="classification-text">{label}</span>
            {value === key && (
              <SafeIcon icon={Icons.Check} size={20} className="selected-icon" />
            )}
          </button>
        ))}
      </div>

      {errors.length > 0 && (
        <div className="validation-errors">
          {errors.map((error, idx) => (
            <span key={idx} className="error-message">{error}</span>
          ))}
        </div>
      )}

      <p className="field-hint">
        Select the most severe classification that applies. Never mark as "Safe to Use" if any fault is marked "Immediately Dangerous".
      </p>
    </div>
  );
}